export const RQ_APPOINTMENT_ADD_API = {
  url: 'api/appointments/add',
  method: 'POST',
  auth: true,
};

export const RQ_APPOINTMENT_UPDATE_API = {
  url: 'api/appointments/update/<%= id %>',
  method: 'PATCH',
  auth: true,
};

export const RQ_APPOINTMENT_LOOKUP_ID_API = {
  url: 'api/appointments/lookup/<%= id %>',
  method: 'GET',
  auth: true,
};

export const RQ_APPOINTMENT_LOOKUP_API = {
  url: 'api/appointments/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_APPOINTMENT_BOOKING_API = {
  url: 'api/appointments/lookup/booking/<%= bookingType %>',
  method: 'GET',
  auth: true,
};

export const RQ_APPOINTMENT_DELETE_API = {
  url: 'api/appointments/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};
